module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.invoice.order) ? _c('div', {
    staticClass: "ls-theme-cyanogen container subscribe-wrapper"
  }, [_c('header', {
    staticClass: "main-header ls-md-margin-top"
  }, [_c('h1', {
    staticClass: "trade-name"
  }, [_vm._v(_vm._s(_vm.basicSeller.trade_name || _vm.basicSeller.name))]), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t('payments.messages.finalized_payment')))])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-details col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8 col-sm-6 ls-no-padding-left"
  }, [_c('h4', {
    staticClass: "green ls-txt-center ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('payments.messages.successful_payment')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', {
    staticClass: "payment-info"
  }, _vm._l((_vm.steps), function(step) {
    return _c('li', {
      staticClass: "ls-md-margin-bottom"
    }, [_c('div', [_c('i', {
      class: step.icon,
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "ls-no-margin ls-txt-justify",
      domProps: {
        "innerHTML": _vm._s(step.description)
      }
    }, [_vm._v(_vm._s(step.description))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12 col-sm-12 col-sm-6 ls-no-padding-left ls-no-padding-right"
  }, [_c('div', {
    staticClass: "full-height ls-no-padding-left ls-no-padding-right"
  }, [_c('invoice-details', {
    staticClass: "ls-md-margin-bottom",
    attrs: {
      "invoice": _vm.invoice
    }
  })], 1)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb430228"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/payments/CheckoutYapayDone.vue
// module id = 826
// module chunks = 1